import { CTA, styled } from '@vw-marketing/us-components';

export const StyledAppButtonCTA = styled(CTA)`
    flex: 1 0 0;
`;